module.exports = __webpack_public_path__ + "img/friend-share-bg.13cb59a1.png";